import { Component, ElementRef } from '@angular/core';
import { LayoutService } from '../../service/layout.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html',
  styleUrls: ['./app-sidebar.component.scss'],
  standalone: false,
})
export class AppSidebarComponent {
  constructor(public el: ElementRef, public layoutService: LayoutService) {}

}